/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RouteModel } from '../../models/route-model';

export interface ApiMasterMenuGetActiveRouteGet$Params {
}

export function apiMasterMenuGetActiveRouteGet(http: HttpClient, rootUrl: string, params?: ApiMasterMenuGetActiveRouteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RouteModel>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterMenuGetActiveRouteGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RouteModel>>;
    })
  );
}

apiMasterMenuGetActiveRouteGet.PATH = '/api/Master/Menu/GetActiveRoute';
